import { t } from "i18next";
import { isNil } from "lodash";

export default function v_time_total_max_hours(value: number | null | undefined, args: { num: number; message?: string }) {
  return {
    message: args.message || t(`Cannot exceed ${args.num} ${args.num === 1 ? 'hour' : 'hours'}`),
    validate: () => {
      if (isNil(value)) {
        return true;
      }
      return value <= args.num * 3600;
    }
  }
}